<template>
  <div class="app-main-inner">
    <div style="width: fit-content">
      <div class="section">
        <el-form ref="basicForm" :inline="true" label-position="left">
          <div class="el-form-item-group">
            <!-- <el-form-item label="MBL" lable-width="60px">
              <el-input v-model="job.mbl" no="3" :disabled="readonly||isCrossTenantSEToSI" />
            </el-form-item> -->
            <el-form-item lable-width="0px">
              <el-checkbox v-model="job.usCustomsClearance" no="5" :disabled="readonly">{{ $t('queryJob.UsCustomsClearance') }}</el-checkbox>
            </el-form-item>
            <el-form-item lable-width="0px">
              <el-checkbox v-model="job.insure" :disabled="readonly">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
            </el-form-item>
            <el-checkbox v-if="showTrucking" v-model="job.landTransportation" no="6" :disabled="readonly">{{ $t('SeaExport.DeliveryToDoor') }}</el-checkbox>
            <el-checkbox v-model="job.importManifest" no="6.5" :disabled="readonly">{{ $t('SeaImport.ImportManifest') }}</el-checkbox>
            <span v-if="!!templateName" class="blue" style="float: right;margin-right: 30px;line-height: 28px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
          </div>
        </el-form>
      </div>
      <master-basic-tab-UICustom-layout :element-blocks="elementBlocks">
        <el-form-item v-if="elementDict.mbl.masterVisible" slot="mbl">
          <line-label slot="label" :class="elementDict.mbl.isRequire ? 'blue' : ''" :label="elementDict.mbl.label" />
          <el-input v-model="job.mbl" no="3" :disabled="readonly||isCrossTenantSEToSI" />
        </el-form-item>
        <el-form-item v-if="elementDict.jobNo.masterVisible" slot="jobNo">
          <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
          <el-input v-model="job.jobNo" no="1" :disabled="true" class="jobNo-color" />
        </el-form-item>
        <el-form-item v-if="elementDict.warehouseNo.masterVisible" slot="warehouseNo">
          <line-label slot="label" :class="elementDict.warehouseNo.isRequire ? 'blue' : ''" :label="elementDict.warehouseNo.label" />
          <el-input v-model="job.warehouseNo" no="2" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.customerRefNo.masterVisible" slot="customerRefNo">
          <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
          <cargo-input v-model="job.customerRefNo" no="4" :disabled="readonly" :trim="true" />
        </el-form-item>
        <template v-if="isZY">
          <el-form-item slot="saleProductCode">
            <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_AllowSaleProduct"
              filterable
              no="allowSaleProduct"
              :disabled="readonly"
              clearable
              :data-filter-function="p => p.statusEnabled && p.seaImportEnabled"
              :default-value="job.saleProductCode || ''"
              @parentCallBack="p => {job.saleProductCode = p.value}"
            />
          </el-form-item>
          <el-form-item slot="fullOrInside">
            <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
              no="fullOrInside"
              :disabled="readonly"
              clearable
              :default-value="job.fullOrInside || ''"
              @parentCallBack="p => {job.fullOrInside = p.value}"
            />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.cargoSource.masterVisible" slot="cargoSource">
          <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
          <el-select
            v-model="job.cargoSource"
            no="7"
            :disabled="readonly"
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
            @change="val=>{pm.cargoSourceChange(val)}"
          >
            <el-option
              v-for="(item,index) in CARGO_SOURCES"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
        <el-form-item v-if="elementDict.customJobType.masterVisible" slot="customJobType">
          <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
          <cargo-advance-select
            no="8"
            filterable
            :clearable="true"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_CutomJobType"
            :static-options="customJobTypeList"
            :method-params="{type:job.lob}"
            :default-value="job.customJobType"
            :callback-params="{key:'customJobType'}"
            @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.secondaryCustomJobType.masterVisible && job.customJobType && secondaryCustomJobTypeList.length > 0" slot="secondaryCustomJobType">
          <line-label slot="label" :class="elementDict.secondaryCustomJobType.isRequire ? 'blue' : ''" :label="elementDict.secondaryCustomJobType.label" />
          <cargo-advance-select
            ref="secondaryCustomJobType"
            no="secondaryCustomJobType"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_CutomJobType"
            filterable
            :cache="false"
            :default-value="job.secondaryCustomJobType"
            :tag-name="isZh?'name':'englishName'"
            :static-options="secondaryCustomJobTypeList"
            @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.salesChannel.masterVisible" slot="salesChannel">
          <line-label slot="label" :class="elementDict.salesChannel.isRequire ? 'blue' : ''" :label="elementDict.salesChannel.label" />
          <el-input v-model="job.salesChannel" no="9" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.trustFromJob.masterVisible && isCrossTenantSEToSI" slot="trustFromJob">
          <line-label slot="label" :class="elementDict.trustFromJob.isRequire ? 'blue' : ''" :label="elementDict.trustFromJob.label" />
          <el-input no="10" :value="job.trustFromJob" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.relatedJob && elementDict.relatedJob.masterVisible && isCrossTenantSEToSI" slot="relatedJob">
          <line-label slot="label" :class="elementDict.relatedJob.isRequire ? 'blue' : ''" :label="elementDict.relatedJob.label" />
          <el-input no="relatedJob" :value="job.relatedJob" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.channelNo.masterVisible && showChannelNo" slot="channelNo">
          <line-label slot="label" :class="elementDict.channelNo.isRequire ? 'blue' : ''" :label="elementDict.channelNo.label" />
          <el-input no="11" :value="job.channelNo" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.designationAgent.masterVisible && visibleDesignationAgent" slot="designationAgent">
          <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
          <cargo-company-select
            no="12"
            :disabled="!controllerEnable.txtDesignationAgent"
            :method-params="{designationAgent:true,active:true}"
            :default-value="job.designationAgent||''"
            tag-name="englishName"
            @change="p=>{pm.designationAgentChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationAgent.masterVisible" slot="destinationAgent">
          <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
          <div style="display: flex;align-items: center">
            <el-tooltip
              v-show="sopImageB"
              no="13"
              :content="$t('SeaExport.SOPReceiver')"
              placement="right-end"
            >
              <div>
                <img
                  :src="sopPic"
                  width="18"
                  height="28"
                  style="padding: 5px 0;cursor: pointer"
                  @click="pm.sopChangeCustomerIdHandler()"
                >
              </div>
            </el-tooltip>
          </div>
          <cargo-company-select
            no="14"
            :disabled="readonly"
            :method-params="{overseaAgent:true,active:true}"
            :default-value="job.destinationAgent||''"
            tag-name="englishName"
            @change="p=>{pm.txtDestinationAgentChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.carrierId.masterVisible" slot="carrierId">
          <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
          <cargo-company-select
            no="15"
            :disabled="!controllerEnable.txtCarrierId||isCrossTenantSEToSI"
            :method-params="{companyLob:'seaImport',seaCmp:true,active:true}"
            :default-value="job.carrierId||''"
            @change="p=>{job.carrierId=p.value;onCarrierIdChange(this.scacList, this.carrierScacEdit)}"
          />
        </el-form-item>
        <!-- 船公司SCAC -->
        <el-form-item v-if="elementDict.carrierScac && elementDict.carrierScac.viewable" slot="carrierScac">
          <line-label slot="label" :class="elementDict.carrierScac.isRequire ? 'blue' : ''" :label="elementDict.carrierScac.label" />
          <cargo-advance-select
            no="carrierScac"
            filterable
            :custom-label="(item)=>`[${item.code}]${item.englishName?item.englishName:item.code}`"
            :filter-tag-names="['code','englishName']"
            :show-custom-label-in-option="true"
            :static-options="scacList"
            tag-value="code"
            :disabled="readonly || !carrierScacEdit || !elementDict.carrierScac.writable"
            :default-value="job.carrierScac||''"
            @parentCallBack="p=>{job.carrierScac = p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.bookingAgent.masterVisible && bookingAgentVisible" slot="bookingAgent">
          <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
          <cargo-company-select
            no="16"
            :disabled="!controllerEnable.txtBookingAgent||isCrossTenantSEToSI"
            :method-params="{bookingAgent:true,companyLob:'seaImport',active:true}"
            :default-value="job.bookingAgent||''"
            @change="p=>{job.bookingAgent=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.exChangeAgent.masterVisible" slot="exChangeAgent">
          <line-label slot="label" :class="elementDict.exChangeAgent.isRequire ? 'blue' : ''" :label="elementDict.exChangeAgent.label" />
          <cargo-company-select
            no="100"
            :disabled="readonly"
            :method-params="{bookingAgent:true,companyLob:'seaImport',active:true}"
            :default-value="job.exChangeAgent||''"
            @change="p=>{job.exChangeAgent=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customsNo && elementDict.customsNo.masterVisible" slot="customsNo">
          <line-label slot="label" :class="elementDict.customsNo.isRequire ? 'blue' : ''" :label="elementDict.customsNo.label" />
          <el-input v-model="job.customsNo" no="17" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-if="elementDict.jobSoNo.masterVisible" slot="jobSoNo">
          <line-label slot="label" :class="elementDict.jobSoNo.isRequire ? 'blue' : ''" :label="elementDict.jobSoNo.label" />
          <so-no-input v-model="job.jobSoNo" no="18" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-if="elementDict.vesselChineseName && elementDict.vesselChineseName.masterVisible" slot="vesselChineseName">
          <line-label slot="label" :class="elementDict.vesselChineseName.isRequire ? 'blue' : ''" :label="elementDict.vesselChineseName.label" />
          <cargo-input v-model="job.vesselChineseName" no="19" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-if="elementDict.vessel.masterVisible" slot="vessel">
          <line-label slot="label" :class="elementDict.vessel.isRequire ? 'blue' : ''" :label="elementDict.vessel.label" />
          <cargo-input v-model="job.vessel" no="20" :disabled="readonly||isCrossTenantSEToSI" :auto-uppercase="isUppercase" />
        </el-form-item>
        <el-form-item v-if="elementDict.voyageFlight.masterVisible" slot="voyageFlight">
          <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input v-model="job.voyageFlight" no="21" :disabled="readonly||isCrossTenantSEToSI" style="flex: 1" :auto-uppercase="isUppercase" />
            <el-checkbox v-model="isTwoVessel" no="22" style="margin-left: 5px" :disabled="readonly">{{ $t('SeaExport.SecondCheck') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.secondVessel.masterVisible && isTwoVessel" slot="secondVessel">
          <line-label slot="label" :class="elementDict.secondVessel.isRequire ? 'blue' : ''" :label="elementDict.secondVessel.label" />
          <cargo-input v-model="job.secondVessel" no="23" :disabled="readonly" :auto-uppercase="isUppercase" />
        </el-form-item>
        <el-form-item v-if="elementDict.secondVoyage.masterVisible && isTwoVessel" slot="secondVoyage">
          <line-label slot="label" :class="elementDict.secondVoyage.isRequire ? 'blue' : ''" :label="elementDict.secondVoyage.label" />
          <cargo-input v-model="job.secondVoyage" no="24" :disabled="readonly" :auto-uppercase="isUppercase" />
        </el-form-item>
        <el-form-item v-if="elementDict.dispatchingPlace.masterVisible" slot="dispatchingPlace">
          <line-label slot="label" :class="elementDict.dispatchingPlace.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlace.label" />
          <cargo-input v-model="job.dispatchingPlace" no="25" :disabled="readonly||isCrossTenantSEToSI" :auto-uppercase="isUppercase" />
        </el-form-item>
        <el-form-item v-if="elementDict.loadingPortCode.masterVisible" slot="loadingPortCode">
          <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
          <cargo-advance-select
            ref="loadingPortCode"
            no="26"
            filterable
            :disabled="readonly||isCrossTenantSEToSI"
            :placeholder="$t('SeaExport.RequiredItem')"
            :select-type="selectTypeNames.basic_data_Seaport"
            :default-value="job.loadingPortCode"
            :method-params="{}"
            @parentCallBack="loadingPortCodeChange"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dischargingPortCode.masterVisible" slot="dischargingPortCode">
          <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
          <cargo-advance-select
            no="27"
            filterable
            :disabled="readonly||isCrossTenantSEToSI"
            :placeholder="$t('SeaExport.RequiredItem')"
            :callback-params="{key:'dischargingPortCode'}"
            :select-type="selectTypeNames.basic_data_Seaport"
            :default-value="job.dischargingPortCode"
            :method-params="{}"
            @parentCallBack="p=>{job.dischargingPortCode=p.value;pm.dischargingPortCode_Change(p.value)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPortCode.masterVisible" slot="destinationPortCode">
          <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
          <cargo-advance-select
            no="destinationPortCode"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_Seaport"
            filterable
            :default-value="job.destinationPortCode"
            :placeholder="$t('SeaExport.RequiredItem')"
            @parentCallBack="p=>{job.destinationPortCode=p.value;pm.destinationPortCodeEasyChange(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPlace.masterVisible" slot="destinationPlace">
          <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
          <cargo-input v-model="job.destinationPlace" no="28" :disabled="readonly||isCrossTenantSEToSI" />
        </el-form-item>
        <el-form-item v-if="elementDict.customsDate.masterVisible" slot="customsDate">
          <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
          <el-date-picker
            v-model="job.customsDate"
            no="29"
            :disabled="readonly"
            clearable
            style="width:100%;"
            type="date"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.bookingDate.masterVisible" slot="bookingDate">
          <line-label slot="label" :class="elementDict.bookingDate.isRequire ? 'blue' : ''" :label="elementDict.bookingDate.label" />
          <el-date-picker
            v-model="job.bookingDate"
            no="30"
            :disabled="readonly"
            type="date"
            style="width:100%;"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.etd.masterVisible" slot="etd">
          <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.etd"
              no="31"
              class="departure-date-picker"
              :disabled="!controllerEnable.dfETD||isCrossTenantSEToSI"
              :placeholder="elementDict.etd.isRequire ? $t('SeaExport.RequiredItem') : ''"
              type="date"
              value-format="yyyy-MM-dd"
              style="flex: 1;margin-right: 5px"
              clearable
              @input="etdChange"
            />
            <span>{{ job.sailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.eta.masterVisible" slot="eta">
          <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.eta"
              no="32"
              :disabled="readonly"
              :placeholder="$t('SeaExport.RequiredItem')"
              style="flex: 1;margin-right: 5px"
              type="date"
              clearable
              value-format="yyyy-MM-dd"
              @input="etaChange"
            />
            <span>{{ job.etaSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.atd.masterVisible" slot="atd">
          <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.atd"
              no="33"
              :disabled="readonly"
              style="flex: 1;margin-right: 5px"
              type="date"
              value-format="yyyy-MM-dd"
              @input="atdChange"
            />
            <span>{{ job.atdSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.ata.masterVisible" slot="ata">
          <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
          <div style="display: flex">
            <el-date-picker
              v-model="job.ata"
              no="34"
              :disabled="readonly"
              style="flex: 1;margin-right: 5px"
              type="date"
              clearable
              value-format="yyyy-MM-dd"
              @input="ataChange"
            />
            <span>{{ job.ataSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.arrivalTime.masterVisible" slot="arrivalTime">
          <line-label slot="label" :class="elementDict.arrivalTime.isRequire ? 'blue' : ''" :label="elementDict.arrivalTime.label" />
          <el-date-picker
            v-model="job.arrivalTime"
            no="123"
            :disabled="readonly"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customsBroker.masterVisible" slot="customsBroker">
          <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
          <cargo-advance-select
            no="35"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_Company"
            :data-filter-function="customsBrokerFilter"
            filterable
            :default-value="job.customsBroker||''"
            :method-params="{customsBroker:true,companyLob:'seaImport',active:true}"
            @parentCallBack="p=>{pm.customsBrokerChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customClaim.masterVisible" slot="customClaim">
          <line-label slot="label" :class="elementDict.customClaim.isRequire ? 'blue' : ''" :label="elementDict.customClaim.label" />
          <cargo-advance-select
            no="customsMethod"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_CustomsMode"
            :method-params="{serviceType:2}"
            tag-value="serialNum"
            filterable
            :default-value="job.customClaim"
            @parentCallBack="p=>{job.customClaim=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.customsDeclarationType.masterVisible" slot="customsDeclarationType">
          <line-label slot="label" :class="elementDict.customsDeclarationType.isRequire ? 'blue' : ''" :label="elementDict.customsDeclarationType.label" />
          <cargo-advance-select
            no="customsDeclarationType"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
            filterable
            :default-value="job.customsDeclarationType||''"
            :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
            @parentCallBack="p=>{job.customsDeclarationType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.tradeTerm.masterVisible" slot="tradeTerm">
          <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
          <cargo-advance-select
            no="36"
            filterable
            :disabled="readonly"
            :clearable="false"
            :select-type="selectTypeNames.basic_data_TradeTerm"
            :method-params="{}"
            callback-method-type="value"
            :default-value="job.tradeTerm+''"
            :callback-params="{key:'tradeTerm'}"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.bookingTerm.masterVisible" slot="bookingTerm">
          <line-label slot="label" :class="elementDict.bookingTerm.isRequire ? 'blue' : ''" :label="elementDict.bookingTerm.label" />
          <el-select
            ref="bookingTerm"
            v-model="job.bookingTerm"
            no="37"
            :disabled="readonly||isCrossTenantSEToSI"
            :placeholder="readonly ? '' : $t('SeaExport.PleaseSelect')"
            :clearable="false"
            size="mini"
          >
            <el-option
              v-for="(item,index) in bookingTerms"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.scNo.masterVisible" slot="scNo">
          <line-label slot="label" :class="elementDict.scNo.isRequire ? 'blue' : ''" :label="elementDict.scNo.label" />
          <el-input v-model="job.scNo" no="38" :disabled="readonly" />
        </el-form-item>
        <el-form-item v-if="elementDict.freeDemurrage.masterVisible" slot="freeDemurrage">
          <line-label slot="label" :class="elementDict.freeDemurrage.isRequire ? 'blue' : ''" :label="elementDict.freeDemurrage.label" />
          <auto-number-input
            v-model="job.freeDemurrage"
            no="39"
            :precision="0"
            :min="0"
            :disabled="readonly"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.freeDetention.masterVisible" slot="freeDetention">
          <line-label slot="label" :class="elementDict.freeDetention.isRequire ? 'blue' : ''" :label="elementDict.freeDetention.label" />
          <auto-number-input
            v-model="job.freeDetention"
            no="40"
            :precision="0"
            :min="0"
            :disabled="readonly"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.terminalCompany.masterVisible" slot="terminalCompany">
          <line-label slot="label" :class="elementDict.terminalCompany.isRequire ? 'blue' : ''" :label="elementDict.terminalCompany.label" />
          <cargo-company-select
            no="terminalCompany"
            :disabled="readonly"
            :method-params="{terminalCompany:true,companyLob:'seaImport',active:true}"
            :default-value="job.terminalCompany||''"
            style="width: 100%"
            @change="p=>{JobUtils.terminalCompanyChangeHandler(job, p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.deliveryAddress.masterVisible" slot="deliveryAddress">
          <line-label slot="label" :class="elementDict.deliveryAddress.isRequire ? 'blue' : ''" :label="elementDict.deliveryAddress.label" />
          <cargo-rich-textarea
            v-model="job.deliveryAddress"
            no="deliveryAddress"
            :disabled="readonly"
            style="height: 110px;"
            @dblclick.native="showAdvanceTextDialog($t('Message.TerminalAddress'),job.deliveryAddress,val=>{job.deliveryAddress=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.transportSource.masterVisible" slot="transportSource">
          <line-label slot="label" :class="elementDict.transportSource.isRequire ? 'blue' : ''" :label="elementDict.transportSource.label" />
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_TransportSource"
            no="transportSource"
            :default-value="job.transportSource"
            :cache="false"
            :disabled="readonly"
            tag-value="code"
            placeholder=" "
            @parentCallBack="item=>job.transportSource=item.value"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.statisticArea.masterVisible" slot="statisticArea">
          <line-label slot="label" :class="elementDict.statisticArea.isRequire ? 'blue' : ''" :label="elementDict.statisticArea.label" />
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_StatisticArea"
            no="statisticArea"
            :default-value="job.statisticArea"
            :cache="false"
            :disabled="readonly"
            tag-value="code"
            placeholder=" "
            @parentCallBack="item=>job.statisticArea=item.value"
          />
        </el-form-item>
        <template v-if="elementDict.shipper.masterVisible" slot="shipper">
          <el-form-item label="">
            <div style="display: flex;justify-content: flex-end">
              <el-button no="41" type="primary" :disabled="readonly" @click="pm.onExcerption()">{{ $t('SeaExport.CopyFromOtherBill') }}</el-button>
              <el-button no="42" type="primary" :disabled="readonly" @click="pm.onCodeSearch()">{{ $t('SeaExport.CodeSearching') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              <line-label :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
              <char-count :form="job" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
            </template>
            <div style="display: flex;justify-content: space-between">
              <cargo-input v-model="job.shipperCode" no="43" style="width:80px;margin-right: 5px" :disabled="readonly" :placeholder="readonly ? '' : $t('SeaExport.Code2')" :auto-uppercase="notUppercaseShipperConsigneNotify" />
              <cargo-company-select
                no="44"
                :disabled="readonly"
                :method-params="{shipper:true,active:true}"
                :default-value="job.shipperId||''"
                tag-name="englishName"
                style="flex: 1;margin-bottom: 10px"
                @change="data => {senderAndReceiverChange('shipper',data, 6, notUppercaseShipperConsigneNotify)}"
              />
            </div>
            <cargo-input
              v-model="job.shipperLine1"
              no="45"
              :disabled="readonly"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
              @dblclick.native="showSenderAndReceiverDialog('shipper',6, false, notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.consignee.masterVisible" slot="consignee">
          <template slot="label">
            <line-label :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
            <char-count :form="job" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <div style="display: flex;justify-content: space-between">
            <cargo-input
              v-model="job.consigneeCode"
              no="46"
              style="width:80px;margin-right: 5px"
              :disabled="readonly"
              :placeholder="readonly ? '' : $t('SeaExport.Code2')"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="pm.qConsigneeCode_focusOutHandler()"
            />
            <cargo-company-select
              no="47"
              :disabled="readonly"
              :method-params="{consignee:true,active:true}"
              :default-value="job.consigneeId||''"
              tag-name="englishName"
              style="flex: 1;margin-bottom: 10px"
              @change="data => {senderAndReceiverChange('consignee',data, 6, true, notUppercaseShipperConsigneNotify)}"
            />
          </div>
          <cargo-input
            v-model="job.consigneeLine1"
            no="48"
            :disabled="readonly"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            :use-read-only="true"
            :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
            @dblclick.native="showSenderAndReceiverDialog('consignee',6, false, notUppercaseShipperConsigneNotify)"
            @blur="pm.qConsigneeAddr_focusOutHandler()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.notify.masterVisible" slot="notify">
          <template slot="label">
            <line-label :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
            <char-count :form="job" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <div style="display: flex;justify-content: space-between">
            <cargo-input v-model="job.notifyCode" no="49" style="width:80px;margin-right: 5px" :disabled="readonly" :placeholder="readonly ? '' : $t('SeaExport.Code2')" :auto-uppercase="notUppercaseShipperConsigneNotify" />
            <cargo-company-select
              no="50"
              :disabled="readonly"
              :method-params="{notify:true,active:true}"
              :default-value="job.notifyId||''"
              tag-name="englishName"
              style="flex: 1;margin-bottom: 10px"
              @change="data => {senderAndReceiverChange('notify',data, 6, notUppercaseShipperConsigneNotify)}"
            />
          </div>
          <cargo-input
            v-model="job.notifyLine1"
            no="51"
            :disabled="readonly"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
            :use-read-only="true"
            @dblclick.native="showSenderAndReceiverDialog('notify',6,false, notUppercaseShipperConsigneNotify)"
          />
        </el-form-item>
        <el-form-item
          v-if="elementDict.seaEq.masterVisible"
          slot="seaEq"
          label-width="0"
          class="auto-width"
        >
          <booking-sea-eq-data-grid
            :value="seaEqList"
            :container-load-type="job.containerLoadType"
            :is-edit="isEdit"
            :job="job"
            :hide-container-no="false"
            @eqQuantityChange="eqQuantityChangeHandler"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoEnglishName.masterVisible" slot="cargoEnglishName">
          <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
          <cargo-rich-textarea
            v-model="job.cargoEnglishName"
            :show-count="true"
            no="52"
            :disabled="readonly||isCrossTenantSEToSI"
            :text-chars="englishNameMaxChars"
            :warning-count="englishNameWarningCount"
            :auto-uppercase="isUppercaseByConfig"
            style="height: 110px;"
            @change="pm.txtCargoEnglishNameChangeHandler()"
            @dblclick.native="showAdvanceTextDialog($t('queryJob.englishDescriptionOfGoods'),job.cargoEnglishName,val=>{job.cargoEnglishName=val},false,null,isUppercaseByConfig , {
              warningCount: englishNameWarningCount,
              maxChar: englishNameMaxChars
            });focusAdvanceTextInput()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoChineseName.masterVisible" slot="cargoChineseName">
          <line-label slot="label" :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
          <cargo-rich-textarea
            v-model="job.cargoChineseName"
            :show-count="true"
            no="53"
            :disabled="readonly"
            :text-chars="maxChars"
            :warning-count="warningCount"
            :auto-half-word="false"
            style="height: 110px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val});focusAdvanceTextInput()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.mark.masterVisible" slot="mark">
          <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
          <cargo-rich-textarea
            v-model="job.mark"
            :show-count="true"
            no="54"
            :disabled="readonly||isCrossTenantSEToSI"
            :text-chars="markMaxChars"
            :warning-count="markWarningCount"
            :auto-uppercase="isUppercaseByConfig"
            style="height: 110px;"
            @change="onMarkChange"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,val=>{job.mark=val},false,null,isUppercaseByConfig , {
              warningCount: markWarningCount,
              maxChar: markMaxChars
            });focusAdvanceTextInput()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.incoTerm.masterVisible" slot="incoTerm">
          <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
          <cargo-advance-select
            no="55"
            filterable
            :disabled="readonly||isCrossTenantSEToSI"
            :select-type="selectTypeNames.basic_data_IncoTerm"
            :method-params="{}"
            callback-method-type="value"
            :default-value="job.incoTerm+''"
            :callback-params="{key:'incoTerm'}"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.depositReceived.masterVisible" slot="depositReceived">
          <line-label slot="label" :class="elementDict.depositReceived.isRequire ? 'blue' : ''" :label="elementDict.depositReceived.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input-number
              no="56"
              :value="job.depositReceived===0 ? undefined: job.depositReceived"
              style="flex-grow: 1"
              :disabled="readonly"
              :controls="false"
              :precision="3"
              @input="val=>{job.depositReceived=val}"
            />
            <span>{{ localCurrency }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.quantityActual.masterVisible" slot="quantityActual">
          <line-label slot="label" :class="elementDict.quantityActual.isRequire ? 'blue' : ''" :label="elementDict.quantityActual.label" />
          <auto-number-input
            v-model="job.quantityActual"
            no="57"
            :precision="0"
            :min="0"
            :disabled="readonly||isCrossTenantSEToSI"
            @change="pm.quantityFocusInHandler()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.packing.masterVisible" slot="packing">
          <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
          <cargo-packing-select
            no="58"
            :disabled="readonly||isCrossTenantSEToSI"
            :default-value="job.packing"
            @change="p=>{job.packing=p.value;pm.chargePacking()}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.weightActual.masterVisible" slot="weightActual">
          <line-label slot="label" :class="elementDict.weightActual.isRequire ? 'blue' : ''" :label="elementDict.weightActual.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="job.weightActual"
              no="59"
              :precision="3"
              :min="0"
              :disabled="readonly||isCrossTenantSEToSI"
              @change="weightContractChange"
            />
            <span>KGS</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cubageActual.masterVisible" slot="cubageActual">
          <line-label slot="label" :class="elementDict.cubageActual.isRequire ? 'blue' : ''" :label="elementDict.cubageActual.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="job.cubageActual"
              no="60"
              :precision="3"
              :min="0"
              :disabled="readonly||isCrossTenantSEToSI"
              @change="cubageContractChange"
            />
            <span>CBM</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.chargeWeight.masterVisible" slot="chargeWeight">
          <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
          <div style="display: flex">
            <auto-number-input
              v-model="job.chargeWeight"
              no="61"
              :precision="3"
              :min="0"
              :disabled="!controllerEnable.txtChargeWeight||isCrossTenantSEToSI"
              @change="pm.chargeWeightChangeHandler()"
            />
            <span>M/T</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.containerLoadType.masterVisible" slot="containerLoadType">
          <line-label slot="label" :class="elementDict.containerLoadType.isRequire ? 'blue' : ''" :label="elementDict.containerLoadType.label" />
          <cargo-advance-select
            no="62"
            filterable
            :clearable="false"
            :disabled="readonly"
            :select-type="selectTypeNames.local_cache_ImportConstants$_cargoTypeInputList"
            callback-method-type="value"
            :default-value="job.containerLoadType"
            :tag-name="$store.getters.language==='zh'?'chineseName':'englishName'"
            tag-value="code"
            :callback-params="{key:'containerLoadType'}"
            @parentCallBack="obj=>pm.qCargoType_Change(obj)"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.freightTermMBL.masterVisible" slot="freightTermMBL">
          <line-label slot="label" :class="elementDict.freightTermMBL.isRequire ? 'blue' : ''" :label="elementDict.freightTermMBL.label" />
          <cargo-advance-select
            no="63"
            filterable
            :clearable="false"
            :disabled="readonly||isCrossTenantSEToSI"
            :select-type="selectTypeNames.basic_data_ShippingTerm"
            :method-params="{}"
            callback-method-type="value"
            :default-value="job.freightTermMBL+''"
            :callback-params="{key:'freightTermMBL'}"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.releaseTypeMbl.masterVisible" slot="releaseTypeMbl">
          <line-label slot="label" :class="elementDict.releaseTypeMbl.isRequire ? 'blue' : ''" :label="elementDict.releaseTypeMbl.label" />
          <cargo-advance-select
            no="64"
            :disabled="readonly"
            :clearable="false"
            :select-type="selectTypeNames.local_cache_ImportConstants$_importReleaseTypes"
            callback-method-type="value"
            :headers="[$t('Tool.Code')]"
            :fields="['code']"
            :default-value="job.releaseTypeMbl"
            :tag-name="$store.getters.language==='zh'?'chineseName':'englishName'"
            tag-value="code"
            :callback-params="{key:'releaseTypeMbl'}"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.paymentTermMBL.masterVisible" slot="paymentTermMBL">
          <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
          <cargo-advance-select
            no="65"
            filterable
            :clearable="false"
            :disabled="readonly||isCrossTenantSEToSI"
            :select-type="selectTypeNames.basic_data_PaymentTerm"
            :method-params="{}"
            callback-method-type="value"
            :default-value="job.paymentTermMBL+''"
            :callback-params="{key:'paymentTermMBL'}"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.portDistrict.masterVisible" slot="portDistrict">
          <line-label slot="label" :class="elementDict.portDistrict.isRequire ? 'blue' : ''" :label="elementDict.portDistrict.label" />
          <cargo-input v-model="job.portDistrict" no="66" :disabled="readonly" :auto-uppercase="isUppercase" />
        </el-form-item>
        <el-form-item v-if="elementDict.transDate.masterVisible" slot="transDate">
          <line-label slot="label" :class="elementDict.transDate.isRequire ? 'blue' : ''" :label="elementDict.transDate.label" />
          <el-date-picker
            v-model="job.transDate"
            no="67"
            :disabled="readonly"
            type="date"
            clearable
            value-format="yyyy-MM-dd"
            style="width: 100%"
            @change="pm.dfCustDate_focusOutHandler()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.deliverDate.masterVisible" slot="deliverDate">
          <line-label slot="label" :class="elementDict.deliverDate.isRequire ? 'blue' : ''" :label="elementDict.deliverDate.label" />
          <el-date-picker
            v-model="job.deliverDate"
            no="68"
            :disabled="readonly"
            type="date"
            clearable
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.arriveStorageDate.masterVisible" slot="arriveStorageDate">
          <line-label slot="label" :class="elementDict.arriveStorageDate.isRequire ? 'blue' : ''" :label="elementDict.arriveStorageDate.label" />
          <el-date-picker
            v-model="job.arriveStorageDate"
            no="69"
            :disabled="readonly"
            type="date"
            clearable
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.warehouseCmp.masterVisible && openWarehouse" slot="warehouseCmp">
          <line-label slot="label" :class="elementDict.warehouseCmp.isRequire ? 'blue' : ''" :label="elementDict.warehouseCmp.label" />
          <cargo-company-select
            ref="warehouse"
            no="70"
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{warehouse:true,active:true}"
            :default-value="job.warehouseCmp||''"
            :static-options="warehouseList"
            @change="p=>{pm.warehouseCmpChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.warehouseName.masterVisible && openWarehouse" slot="warehouseName">
          <line-label slot="label" :class="elementDict.warehouseName.isRequire ? 'blue' : ''" :label="elementDict.warehouseName.label" />
          <el-select
            v-model="job.warehouseName"
            no="warehouseName"
            :disabled="readonly || !job.warehouseCmp"
            :allow-create="true"
            filterable
            :clearable="true"
            @change="warehouseNameChangeHandler"
          >
            <el-option
              v-for="(item,index) in warehouseNameList"
              :key="index"
              :label="item.warehouseName"
              :value="item.warehouseName"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.txtSalesOffice.masterVisible" slot="txtSalesOffice">
          <line-label slot="label" :class="elementDict.txtSalesOffice.isRequire ? 'blue' : ''" :label="elementDict.txtSalesOffice.label" />
          <el-input v-model="txtSalesOffice" no="71" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.sales.masterVisible" slot="sales">
          <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
          <cargo-user-select
            ref="sales"
            no="72"
            :disabled="!saleEnabled"
            :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
            :default-value="job.sales||''"
            :static-options="salesList"
            :placeholder="salesPrompt"
            @change="p=>{pm.salesChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoSalesId.masterVisible" slot="cargoSalesId">
          <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
          <cargo-user-select
            no="73"
            :disabled="readonly"
            :method-params="{category:'role',shape:'salesOfGoods'}"
            :default-value="job.cargoSalesId||''"
            @change="p=>{job.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.salesDepartment.masterVisible" slot="salesDepartment">
          <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
          <cargo-department-new-select
            no="74"
            :disabled="readonly || (isEdit && (job.sales=== 0 || !job.sales))"
            :sales-id="Number(job.sales)"
            :enables="true"
            :office-id="job.salesOffice"
            :department-id="Number(job.salesDepartment)"
            @change="p=>{job.salesDepartment=p.value;pm.departmentChargeHandler()}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.opOffice.masterVisible" slot="opOffice">
          <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
          <cargo-advance-select
            no="75"
            filterable
            :disabled="readonly || opOfficeDisabled"
            :select-type="selectTypeNames.basic_data_Office"
            :default-value="job.opOffice"
            :static-options="cacheOffices"
            placeholder=""
            @parentCallBack="p=>{job.opOffice=p.value;job.opDepartment=0;pm.opOfficeChangeHandler()}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.opDepartment.masterVisible" slot="opDepartment">
          <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
          <cargo-department-select
            ref="department"
            no="76"
            :disabled="!saleEnabled"
            :enables="true"
            :office-id="Number(job.opOffice)"
            :department-id="Number(job.opDepartment)"
            @change="p=>{job.opDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.op.masterVisible" slot="op">
          <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
          <cargo-user-select
            no="77"
            :disabled="readonly"
            :method-params="{officeId:job.opOffice,category:'role',shape:'siop'}"
            :default-value="job.op||''"
            :static-options="userPortRoleData.op"
            @change="p=>{job.op=p.value;pm.opChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrOffice.masterVisible" slot="csrOffice">
          <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
          <cargo-office-select
            no="csrOffice"
            :disabled="true"
            :office-id="Number(job.csrOffice)"
            @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrDepartment.masterVisible" slot="csrDepartment">
          <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
          <cargo-department-select
            no="csrDepartment"
            :office-id="Number(job.csrOffice)"
            :enables="true"
            :disabled="readonly"
            :department-id="Number(job.csrDepartment)"
            @change="p=>{job.csrDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csr.masterVisible" slot="csr">
          <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
          <cargo-user-select
            ref="csr"
            no="78"
            :disabled="readonly"
            :method-params="{officeId:pm.isEntrustOrder||job.salesOffice===1?job.opOffice:job.salesOffice,category:'role',shape:'csr'}"
            :default-value="job.csr||''"
            :static-options="userPortRoleData.csr"
            @change="p=>{pm.csrChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.siteOP.masterVisible" slot="siteOP">
          <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
          <cargo-user-select
            :disabled="readonly"
            :method-params="{officeId:job.opOffice,category:'role',shape:'siteOp'}"
            :default-value="job.siteOP||''"
            :static-options="userPortRoleData.siteOp"
            @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.overseaOp.masterVisible" slot="overseaOp">
          <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
          <cargo-user-select
            ref="overseaOp"
            no="overseaOp"
            :disabled="readonly"
            class="input2"
            :default-value="job.overseaOp||''"
            :method-params="{category:'role',shape:'overseaOp'}"
            :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
            :merge-load="true"
            @change="p=>{
              job.overseaOp = p.value
              OverseaCustomerUtils.overseaOpChangeHandler(view, p)
            }"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dcOffice.masterVisible" slot="dcOffice">
          <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
          <cargo-office-select
            no="dcOffice"
            :disabled="true"
            :office-id="Number(job.dcOffice)"
            @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dcDepartment.masterVisible" slot="dcDepartment">
          <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
          <cargo-department-select
            no="dcDepartment"
            :office-id="Number(job.dcOffice)"
            :enables="true"
            :disabled="readonly"
            :department-id="Number(job.dcDepartment)"
            @change="p=>{job.dcDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dc.masterVisible" slot="dc">
          <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
          <cargo-user-select
            ref="dc"
            no="79"
            :disabled="readonly"
            :method-params="{officeId:job.opOffice,category:'role',shape:'doc'}"
            :default-value="job.dc||''"
            :static-options="userPortRoleData.doc"
            @change="p=>{pm.dcChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.userDefinedRoleId1.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId1">
          <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
          <cargo-user-select
            ref="userDefinedRoleId1"
            no="userDefinedRoleId1"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
            :default-value="job.userDefinedRoleId1||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole1"
            @change="p=>{userDefinedRoleId1Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.userDefinedRoleId2.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId2">
          <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
          <cargo-user-select
            ref="userDefinedRoleId2"
            no="userDefinedRoleId2"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
            :default-value="job.userDefinedRoleId2||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole2"
            @change="p=>{userDefinedRoleId2Handler(p)}"
          />
        </el-form-item>
        <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.masterVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
          <micro-app
            name="child-user-defined-role-si-master-userDefinedRoleId3"
            :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
            router-mode="pure"
            destroy
            @datachange="userDefinedRoleDataChangeUI"
          />
        </div>
        <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.masterVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
          <micro-app
            name="child-user-defined-role-si-master-userDefinedRoleId4"
            :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
            router-mode="pure"
            destroy
            @datachange="userDefinedRoleDataChangeUI"
          />
        </div> -->
        <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId3">
          <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
          <cargo-user-select
            ref="userDefinedRoleId3"
            no="userDefinedRoleId3"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
            :default-value="job.userDefinedRoleId3||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole3"
            @change="p=>{pm.userDefinedRoleId3Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId4">
          <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
          <cargo-user-select
            ref="userDefinedRoleId4"
            no="userDefinedRoleId4"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
            :default-value="job.userDefinedRoleId4||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole4"
            @change="p=>{pm.userDefinedRoleId4Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId5">
          <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
          <cargo-user-select
            ref="userDefinedRoleId5"
            no="userDefinedRoleId5"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
            :default-value="job.userDefinedRoleId5||''"
            :disabled="readonly"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleId5Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId6">
          <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
          <cargo-user-select
            ref="userDefinedRoleId6"
            no="userDefinedRoleId6"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
            :default-value="job.userDefinedRoleId6||''"
            :disabled="readonly"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleId6Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId7">
          <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
          <cargo-user-select
            ref="userDefinedRoleId7"
            no="userDefinedRoleId7"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
            :default-value="job.userDefinedRoleId7||''"
            :disabled="readonly"
            :merge-load="true"
            @change="p=>{pm.userDefinedRoleId7Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
          <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
          <cargo-user-select
            ref="userDefinedRoleId8"
            no="userDefinedRoleId8"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
            :default-multiple-value="toNumArray(job.userDefinedRoleId8)"
            :disabled="readonly"
            :multiple="true"
            :merge-load="true"
            :placeholder="readonly ? ' ' : ''"
            @change="p=>{job.userDefinedRoleId8=toTxt(p.value)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.remarks.masterVisible" slot="remarks">
          <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
          <cargo-rich-textarea
            v-model="job.remarks"
            no="80"
            :disabled="readonly||isCrossTenantSEToSI"
            :text-chars="maxChars"
            :warning-count="warningCount"
            :is-trim="true"
            style="height: 110px;"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val});focusAdvanceTextInput()"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField1.masterVisible" slot="userDefinedField1">
          <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
          <el-input
            v-model="job.userDefinedField1"
            no="81"
            :disabled="readonly"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,job.userDefinedField1,val=>{job.userDefinedField1=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField2.masterVisible" slot="userDefinedField2">
          <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
          <el-input
            v-model="job.userDefinedField2"
            no="82"
            type="textarea"
            :rows="5"
            :disabled="readonly"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,job.userDefinedField2,val=>{job.userDefinedField2=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField3.masterVisible" slot="userDefinedField3">
          <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
          <el-input
            v-model="job.userDefinedField3"
            no="83"
            type="textarea"
            :rows="5"
            :disabled="readonly"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,job.userDefinedField3,val=>{job.userDefinedField3=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField4.masterVisible" slot="userDefinedField4">
          <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
          <el-input
            v-model="job.userDefinedField4"
            no="84"
            type="textarea"
            :rows="5"
            :disabled="readonly"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,job.userDefinedField4,val=>{job.userDefinedField4=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.masterVisible" slot="taxNature">
          <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
          <el-select
            v-model="job.taxNature"
            :disabled="readonly"
            no="taxNature"
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
          >
            <el-option
              v-for="(item,index) in TAX_NATURES"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
        <el-form-item v-if="elementDict.rateType && elementDict.rateType.masterVisible" slot="rateType">
          <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
          <el-select
            v-model="job.rateType"
            :disabled="readonly"
            no="rateType"
            clearable
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
          >
            <el-option
              v-for="(item,index) in rateType"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
      </master-basic-tab-UICustom-layout>
      <div class="section">
        <div class="form-row">
          <div class="title" style="width: 100%">
            {{ $t('SeaExport.TicketsInfo') }}
            <div ref="division" class="division" :style="{height:divisionHeight+'px'}" @mousedown="divisionEnabled=true">
              <div class="line" style="margin-top:2px" />
              <div class="line" />
            </div>
          </div>
          <div v-show="readonly" style="display:flex;justify-content: flex-start;margin-bottom: 5px;line-height: 28px;">
            <span style="margin-right: 5px;">{{ $t('SeaExport.TotalTickets') }}:</span><span style="margin-right: 5px;">{{ job.lclSlaves.length }}</span>
            <div v-show="viewSource === 'bookingWorkspace'" class="triggers">
              <el-button type="primary" no="85" :disabled="isEdit||viewSource === 'financeDetail' || viewSource === 'salesDetail'" @click="pm.btnCreate_clickHandler()">{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button type="primary" no="86" :disabled="!selectedRow ||viewSource === 'financeDetail' || viewSource === 'salesDetail'" @click="btnLcLEditClickHandler()">{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button type="primary" no="87" :disabled="isEdit||viewSource === 'financeDetail' || viewSource === 'salesDetail'" @click="pm.btnAdd_clickHandler()">{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button type="danger" no="88" :disabled="!selectedRow||viewSource === 'financeDetail' || viewSource === 'salesDetail'" @click="pm.btnRemove_clickHandler()">{{ $t('SeaExport.RemoveTickets') }}</el-button>
              <el-button type="primary" no="89" :disabled="isEdit||viewSource === 'financeDetail' || viewSource === 'salesDetail'" @click="pm.onBatchPrint()">{{ $t('SeaExport.BatchPrint') }}</el-button>
            </div>
          </div>
          <div style="min-height: 200px;flex-direction: column">
            <div ref="slaveDiv" style="display: flex;height:300px;">
              <cargo-ag-grid
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :row-data="job.lclSlaves||[]"
                @gridReady="params=>{gridApi=params.api}"
              />
            </div>
            <div style="display: flex;justify-content: flex-end">
              <div>{{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotal.lblTotalQuantity }} </div>
              <div>{{ $t('SeaExport.TotalWeight2') }}：{{ lbTotal.lblTotalWeight }} </div>
              <div>{{ $t('SeaExport.TotalCubage') }}：{{ lbTotal.lblTotalCubage }} </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <cargo-contacts-info-dialog
      v-if="showContactsInfoDialog"
      :visible.sync="showContactsInfoDialog"
      :customer-id="job.customerId"
      :customer-contact="job.customerContact"
    />
    <sop-dialog
      :visible.sync="showSopDialog"
      :cmp-idx="sopDialog.cmpIdx"
      :job="job"
      :agent="sopDialog.agent"
      lob="SI"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />

    <!-- 高级文本弹框 -->
    <el-dialog
      ref="advanceTextDialog"
      v-el-drag-dialog
      no="90"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="!readonly" no="xxx" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="91"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!--  单号抄录-->
    <import-prompt-title-dialog
      :visible.sync="importPromptTitleDialog.visible"
      :lob="job.lob"
      @selected="p=>{pm.onExcerptionChangeFunc(p)}"
    />

    <!--  代码检索-->
    <import-bill-address-title-dialog :visible.sync="billAddressDialog.visible" :job="job" @callback="p=>{pm.codeSearchCallback(p)}" />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      v-if="templateSelectorDialog.visible"
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
    />

    <!-- 加入拼箱工作单查询弹窗 -->
    <query-lcl-dialog
      :visible.sync="queryLclDialog.visible"
      :job="job"
      @callback="rows=>{pm.queryLclWindowReturnHandler(rows)}"
    />
    <!-- 票数填写弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="92"
      :visible.sync="ticketDialog.visible"
      :title="$t('SeaExport.FillInQuantityOfVotes')"
      width="270px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="50px" label-position="right">
        <el-form-item :label="$t('SeaExport.Number')+'：'">
          <el-input-number v-model="ticketDialog.value" :precision="0" :min="1" :max="50" :controls="false" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="93" type="primary" @click="pm.toAddTicket()">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="94" type="primary" @click="ticketDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import masterBasicTabUICustomLayout from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/masterBasicTabUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import masterBasicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/masterBasicTab.vue'
import StrUtils from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'MasterBasicTabUICustom',
  components: { masterBasicTabUICustomLayout },
  extends: masterBasicTab,
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      userDefinedRoleDataUI: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.job ? this.job.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      },
      scacList: [],
      carrierScacEdit: false
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      this.scacList = await JobUtils.getScacList(this.job.carrierScac)
    },
    loadPageConfig() {
      const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SI_BOOKING_BASIC, this.$store.getters.currentOfficeId)
      this.elementBlocks = pageConfig.elementBlocks
      this.elementDict = pageConfig.elementDict
      this.fieldDict = pageConfig.fieldDict
      this.carrierScacEdit = JobUtils.checkCarrierScacEdit(this.elementDict)
    },
    async validateForm() {
      const form = this.job
      for (const key in this.fieldDict) {
        const field = this.fieldDict[key]
        if (field.masterVisible && field.isRequire) {
          if (key === 'secondaryCustomJobType') {
            if (!(this.job.customJobType && this.secondaryCustomJobTypeList.length > 0)) {
              continue
            }
          }
          if (key === 'measurements') {
            continue
          }
          if (key === 'userDefinedRoleId1' || key === 'userDefinedRoleId2') {
            if (!this.isAddUserDefinedRoles) {
              continue
            }
          }
          if (key.startsWith('shipper') || key.startsWith('consignee') || key.startsWith('notify')) {
            continue
          }
          if (key === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'masterBasicTab')
            }
          } else if (key === 'customClaim') {
            if (!ColumnUtils.customClaimLabelFunc(form.customClaim)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.customClaim.label]), 'masterBasicTab')
            }
          } else if (key === 'customsDeclarationType') {
            if (!ColumnUtils.customClaim2LabelFunc(form.customsDeclarationType)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.customsDeclarationType.label]), 'masterBasicTab')
            }
          } else if (key === 'releaseTypeMbl') {
            const label = ColumnUtils.releaseTypeLabelFunc(form[key])
            if (!label) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'masterBasicTab')
            }
          } else if (key === 'taxNature') {
            if (form[key] === '' || form[key] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'masterBasicTab')
            }
          }
        }
      }
      if (this.elementDict.shipper.masterVisible && this.elementDict.shipper.isRequire) {
        let shipperLine = ''
        for (let i = 1; i <= 7; ++i) {
          shipperLine += form['shipperLine' + i]
        }
        if (StrUtils.isEmpty(shipperLine) || StrUtils.isEmpty(form.shipperCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.shipper.label]), 'masterBasicTab')
        }
      }
      if (this.elementDict.consignee.masterVisible && this.elementDict.consignee.isRequire) {
        let consigneeLine = ''
        for (let i = 1; i <= 7; ++i) {
          consigneeLine += form['consigneeLine' + i]
        }
        if (StrUtils.isEmpty(consigneeLine) || StrUtils.isEmpty(form.consigneeCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.consignee.label]), 'masterBasicTab')
        }
      }
      if (this.elementDict.notify.masterVisible && this.elementDict.notify.isRequire) {
        let notifyLine = ''
        for (let i = 1; i <= 7; ++i) {
          notifyLine += form['notifyLine' + i]
        }
        if (StrUtils.isEmpty(notifyLine) || StrUtils.isEmpty(form.notifyCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.notify.label]), 'masterBasicTab')
        }
      }
      if (this.elementDict.seaEq && this.elementDict.seaEq.masterVisible && this.elementDict.seaEq.isRequire) {
        if (!this.seaEqList || this.seaEqList.length === 0) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.seaEq.label]), 'masterBasicTab')
        }
        for (const seaEq of this.seaEqList) {
          if (!seaEq.eqQuantity) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.ContainerAmount')]), 'masterBasicTab')
          }
        }
      }
      if (this.elementDict.warehouseCmp && this.elementDict.warehouseCmp.masterVisible && this.elementDict.warehouseCmp.isRequire) {
        if (!form.warehouseCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseCmp.label]), 'masterBasicTab')
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setUserDefinedRoleDataUI() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData3.fieldData = this.job.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-si-master-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData4.fieldData = this.job.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-si-master-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChangeUI(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleDataUI()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.job.userDefinedRoleId3 = e.detail.data.fieldData
            this.userDefinedRoleId3Handler(this.job.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.job.userDefinedRoleId4 = e.detail.data.fieldData
            this.userDefinedRoleId4Handler(this.job.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">

  .jobNo-color.el-input {
    &.is-disabled {
      .el-input__inner{
        background: #99FF66;
      }
    }
  }
</style>

<!-- 中文样式 -->
<style scoped lang="scss">
#app.zh {
  .section::v-deep {
    &.center-two {
      width: 400px;
    }
  }
}
</style>

<!-- 英文样式 -->
<style scoped lang="scss">
#app.en {
  .section::v-deep {
    &.center-first {
      min-width: 420px;
    }
    &.center-two {
      width: 442px;
    }
    &.center-three {
      min-width: 364px;
    }
    &.center-four {
      width: 310px;
    }
  }
}
</style>

<style scoped>
.division {
  display: inline-block;
  width: 18px;
  margin-left: calc(40%);
  padding: 1px 0;
  cursor: ns-resize;
}
.division .line {
  width: 100%;
  height: 0px;
  margin-bottom: 1px;
  border-bottom: 2px solid #bdbdbd;
}
</style>
